import React from 'react'
import _ from 'lodash'
import '../assets/css/components/key-array-table.css'
import PropTypes from 'prop-types'

/* Component for displaying a 2-column, table-style layout.
 * This is ideal for display data where a single row can have
 * multiple sub-rows. For example:
 *
 * { title: 'Names', items: ['Kenny', 'David'] }
 *
 * Will display
 * |------------------------|
 * |           |   Kenny    |
 * |   Names   |------------|
 * |           |   David    |
 * |------------------------|
 */
const KeyArrayTable = ({ object, tableType }) => {
  const firstRow = (items, title) =>
    <tr key={title}>
      <th className='titled-row' rowSpan={items.length}>{title}</th>
      <td dangerouslySetInnerHTML={{ __html: items[0] }}
        className='clause-row'>
      </td>
    </tr>

  const remainingRows = items =>
    _.map(items.slice(1,items.length), item =>
      <tr key={item}>
        <td dangerouslySetInnerHTML={{ __html: item }} className='clause-row'>
        </td>
      </tr>
    )

  return(
    <table className={'key-array-table '.concat(tableType)}>
      <tbody>
        {_.map(object || {}, (items, title)=>
          [firstRow(items,title)].concat(remainingRows(items))
        )}
      </tbody>
    </table>
  )
}

KeyArrayTable.propTypes={
  object: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string)
  })
}

export default KeyArrayTable
